import { render, staticRenderFns } from "./CriticalEmployeeSecurityStudy.vue?vue&type=template&id=4ddd3858&scoped=true"
import script from "./CriticalEmployeeSecurityStudy.vue?vue&type=script&lang=js"
export * from "./CriticalEmployeeSecurityStudy.vue?vue&type=script&lang=js"
import style0 from "./CriticalEmployeeSecurityStudy.vue?vue&type=style&index=0&id=4ddd3858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddd3858",
  null
  
)

export default component.exports